// Class: lime._internal.backend.html5.GameDeviceData

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Constructor

var GameDeviceData = function() {
	this.connected = true;
	this.buttons = [];
	this.axes = [];
}

// Meta

GameDeviceData.__name__ = "lime._internal.backend.html5.GameDeviceData";
GameDeviceData.__isInterface__ = false;
GameDeviceData.prototype = {
	
};
GameDeviceData.prototype.__class__ = GameDeviceData.prototype.constructor = $hxClasses["lime._internal.backend.html5.GameDeviceData"] = GameDeviceData;

// Init



// Statics




// Export

exports.default = GameDeviceData;